export default [
  {
    path: '/main',
    name: 'main-index',
    // 260909 유저: 구 메인(Main.vue) 폐기 — /intro 가 메인. 로그아웃·404·딥링크 폴백 전부 /intro.
    redirect: '/intro',
    meta: {
      isHeader: false,
      isNav: true,
      isBack: false,
      titleName: 'Main View'
    }
  },
  {
    // 260529 메인 개편 와이어프레임 미리보기 (라이브 메인 미변경). 검증 후 /main으로 승격 예정.
    path: '/main-wire',
    name: 'main-wireframe',
    component: () => import('@/views/main/MainWireframe.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: 'Main Wireframe'
    }
  },
  {
    // 260601 검색 결과 레이아웃 시안 (리스트/격자/앨범/간판네온 비교)
    path: '/search-wire',
    name: 'search-wireframe',
    component: () => import('@/views/main/SearchWireframe.vue'),
    meta: {
      isHeader: false,
      isNav: false,
      isBack: false,
      titleName: 'Search Wireframe'
    }
  },
  {
    path: '/search',
    component: () => import('@/views/main/Search.vue'),
    meta: {
      isHeader: false,
      isNav: true,

      isBack: false,
      titleName: 'Main View'
    }
  },
  {
    path: '/menu/select',
    component: () => import('@/views/main/SmileCrySelect.vue'),
    meta: {
      isHeader: false,
      isNav: true,

      isBack: false,
      titleName: 'Select View'
    }
  },
  {
    // 260825 간판온 소개 랜딩. 진입 판정은 Root.vue + landingGate.js.
    //   260826: 이 화면이 홈이 됐다(NAV_URL().HOME). 앱에서 홈을 눌러 여기 왔는데 하단 네비가
    //   없으면 나갈 길이 사라지므로 isNav 를 켠다. 헤더는 랜딩이 자체로 그린다.
    //   ⚠️ 네비가 하단을 쓰므로 랜딩의 고정 CTA 독은 걷어냈다(고정 바 2개가 겹친다).
    path: '/intro',
    name: 'service-landing',
    component: () => import('@/views/landing/ServiceLanding.vue'),
    meta: {
      isHeader: false,
      isNav: true,
      isBack: false,
      isSearchHeader: false,
      titleName: '간판ON 소개'
    }
  }
];
